const footerLinks = {
  content: [
    { label: '最新快讯', href: '#updates' },
    { label: '热门黑料', href: '#cards' },
    { label: '焦点专题', href: '#carousel' },
    { label: '爆料合集', href: '#index' },
    { label: '黑料热榜', href: '#ranking' },
  ],
  about: [
    { label: '关于吃瓜网51', href: '#about' },
    { label: '吃瓜问答', href: '#faq' },
    { label: '投稿爆料', href: '#contact' },
    { label: '移动吃瓜', href: '#app' },
    { label: '话题热度', href: '#topics' },
  ],
};

export default function Footer() {
  const handleClick = (href: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-2">
              <span className="font-brand text-2xl text-accent-400">吃瓜网51</span>
              <p className="mt-4 text-sm text-background-300 leading-relaxed max-w-md">
                吃瓜网51是国内领先的娱乐八卦与黑料爆料聚合平台，专注最新八卦新闻、内幕消息与热门爆料事件。每日更新娱乐黑料，深度追踪全网焦点，黑料爱好者聚集地。
              </p>
              <div className="flex items-center gap-4 mt-5">
                <a href="#hero" onClick={handleClick('#hero')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#hero" onClick={handleClick('#hero')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#hero" onClick={handleClick('#hero')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors">
                  <i className="ri-vidicon-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">精彩内容</h4>
              <ul className="space-y-3">
                {footerLinks.content.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={handleClick(link.href)}
                      className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">关于本站</h4>
              <ul className="space-y-3">
                {footerLinks.about.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={handleClick(link.href)}
                      className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-50/10">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-500">
                &copy; 2018-2024 吃瓜网51 版权所有 | 本站内容仅供娱乐参考
              </p>
              <div className="flex items-center gap-6">
                <span className="text-xs text-background-500">合作伙伴</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}